/**
 * WARNING: DO NOT EDIT
 * This file is auto-generated and updated by codegen
 */
import { baseActions } from "document-model";
import { renownUserStatsStatsActions } from "./gen/creators.js";

/** Actions for the RenownUserStats document model */

export const actions = { ...baseActions, ...renownUserStatsStatsActions };
